import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralService } from '../../../services/general/general.service';
import { AngularFireAuth } from '@angular/fire/auth';
import firebase from 'firebase/app';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { mergeMapTo } from 'rxjs/operators';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['../../../../shared-styles/auth.scss'],
})
export class LoginComponent implements OnInit {

  // we create form variable
  public form: FormGroup;

  public loading = false;

  public ios: boolean | undefined;

  constructor(
    private formBuilder: FormBuilder,
    public general: GeneralService,
    public auth: AngularFireAuth,
    public afMessaging: AngularFireMessaging,
    private modalService: NgbModal
  ) {
    this.requestPermission();

    if (Capacitor.getPlatform() === 'ios') {
      this.ios = true;
    }else{
      this.ios = false;
    }

    // We create form
    this.form = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(8)]],
    });
  }

  async ngOnInit() {
    localStorage.removeItem('access_token');
  }

  //Dialog to register as teacher or student
  async openDialog(content: any) {
    let response = await this.modalService.open(content, { centered: true })
      .result;
  }

  // We check email is valid
  get emailNoValido() {
    return this.form.get('email')?.invalid && this.form.get('email')?.touched;
  }

  // we check password is valid
  get passwordNoValido() {
    return (
      this.form.get('password')?.invalid && this.form.get('password')?.touched
    );
  }

  //We call service for Login
  async login() {
    try {
      if (this.form.invalid) {
        await this.general.showDanger('given-data-invalid');
        return;
      }
      this.loading = true;
      const response = await this.general.httpPost('login', this.form.value);
      await this.postLogin(response);
    } catch (error: any) {
      await this.general.showErrorForm(error);
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  async loginGoogle() {
    try {
      let provider = new firebase.auth.GoogleAuthProvider();
      provider.addScope('email');

      let response: any = await this.auth.signInWithPopup(provider);

      response = await this.general.httpPost('login/google', {
        token_id: response.credential.idToken,
        email: response.additionalUserInfo.profile.email,
        id: response.additionalUserInfo.profile.id,
      });

      await this.postLogin(response);
    } catch (error: any) {
      await this.general.showErrorForm(error);
      console.log(error);
    }
  }

  async loginFacebook() {
    try {
      let provider = new firebase.auth.FacebookAuthProvider();
      provider.addScope('public_profile');
      provider.addScope('email');
      let response: any = await this.auth.signInWithPopup(provider);

      response = await this.general.httpPost('login/facebook', {
        access_token: response.credential.accessToken,
        email: response.additionalUserInfo.profile.email,
        id: response.additionalUserInfo.profile.id,
      });

      await this.postLogin(response);
    } catch (error: any) {
      await this.general.showErrorForm(error);
      console.log(error);
    }
  }

  async loginApple() {
    try {
      // let response = await this.auth.signInWithPopup(
      //   new firebase.auth.App()
      // );
      // console.log(response);
    } catch (error) {
      console.log(error);
    }
  }

  async postLogin(response: any) {

    if(response.user_rol == 'teacher' || response.user_rol == 'student') {

      try {
      
        localStorage.setItem('access_token', `${response.access_token}`);
  
        await this.general.sleep(200);
       // await this.general.showSuccess('user-successfully-logged');
  
        if (response.timezone) {
          localStorage.setItem('timezone', response.timezone);
        } else {
          await this.general.httpPost('user-update-timezone', {
            timezone: localStorage.getItem('timezone'),
          });
        }
        window.dispatchEvent(new CustomEvent('user:update-timezone'));
        window.dispatchEvent(new CustomEvent('exec:load-user-init-data'));
  
        // Need to be last
        if (response.user_rol === 'teacher') {
          const timezone = this.general.getCurrentTimezone();
          await this.general.httpPost('teacher-check-timezone', {
            timezone,
          });
  
          await this.general.navigate(`/teacher/dashboard`);
          return;

        }else if (response.user_rol === 'student'){
          await this.general.navigate(`/student/dashboard`);
          return;
        }
      } catch (error) {
        await this.general.showErrorForm(error);
        console.log(error);
      }
      
    }else{
      localStorage.clear();
      await this.general.navigate('/auth/login');
    }
    



  }

  requestPermission() {
    // this.afMessaging.
    // this.afMessaging.requestPermission.subscribe(
    //   (token) => {
    //     console.log('Permission granted! Save to the server!', token);
    //   },
    //   (error) => {
    //     console.error(error);
    //   }
    // );
    // this.afMessaging.requestToken.subscribe(
    //   (token) => {
    //     console.log('Permission granted! Save to the server!', token);
    //   },
    //   (error) => {
    //     console.error(error);
    //   }
    // );
  }
}
